import { createListsSlice } from '~/utils/slices/createListsSlice'

import type { ChatThread, ChatThreadsPayload } from '../@types'

const useChatThreadListsSlice = createListsSlice<ChatThread, ChatThreadsPayload['filters']>({
  name: 'chatThreadListsSlice',
})

export default useChatThreadListsSlice
